// extracted by mini-css-extract-plugin
module.exports = {"descriptionTitle":"XyzPlusContentPreviewUi__descriptionTitle__3ImXA"};